import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { normalizeLang } from "../i18n";
import { LEGAL_COPY, SUPPORT_EMAIL } from "../legal/legalContent";
import "./AboutJourneys.css";

function useLang() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return normalizeLang(
    params.get("lang") ||
      (typeof window !== "undefined" ? window.localStorage.getItem("innervoice_lang") : "he")
  );
}

export default function LegalDocument({ kind }) {
  const lang = useLang();
  const dir = lang === "he" ? "rtl" : "ltr";
  const copy = useMemo(() => {
    const block = LEGAL_COPY[kind === "terms" ? "terms" : "privacy"];
    return block[lang] || block.he;
  }, [kind, lang]);

  const qs = useMemo(() => {
    const q = new URLSearchParams();
    q.set("lang", lang);
    return q.toString();
  }, [lang]);

  return (
    <div className="about-page" dir={dir}>
      <div className="about-card legal-doc-card">
        <p className="legal-doc-meta">
          <Link to={`/?${qs}`} className="legal-doc-back">
            {lang === "he" ? "← דף הבית" : lang === "es" ? "← Inicio" : "← Home"}
          </Link>
        </p>
        <h1>{copy.title}</h1>
        <p className="legal-doc-updated">{copy.updated}</p>
        <p className="legal-doc-attorney">{copy.attorney}</p>
        {copy.sections.map((sec, i) => (
          <section key={`${kind}-sec-${i}`} className="legal-doc-section">
            <h2>{sec.h}</h2>
            {sec.p.map((para, j) => (
              <p key={`${kind}-p-${i}-${j}`}>{para}</p>
            ))}
          </section>
        ))}
        <nav className="legal-doc-switch" aria-label="Legal">
          {kind === "privacy" ? (
            <Link to={`/legal/terms?${qs}`}>{lang === "he" ? "תנאי שימוש" : lang === "es" ? "Terminos" : "Terms of Service"}</Link>
          ) : (
            <Link to={`/legal/privacy?${qs}`}>{lang === "he" ? "מדיניות פרטיות" : lang === "es" ? "Privacidad" : "Privacy Policy"}</Link>
          )}
        </nav>
        <p className="legal-doc-support-mail">
          <a href={`mailto:${SUPPORT_EMAIL}`}>
            {lang === "he" ? "יצירת קשר:" : lang === "es" ? "Contacto:" : "Contact:"} {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </div>
  );
}
